
export type FaqItem = {
  question: string;
  answer: string;
};

export type FaqCategory = {
  title: string;
  items: FaqItem[];
};

export const faqCategories: FaqCategory[] = [
  {
    title: "General Questions",
    items: [
      {
        question: "What is IBLI?",
        answer: "The International Business & Leadership Institute (IBLI) is an online education platform offering professional certification courses designed to help learners develop practical, career-relevant skills across multiple disciplines."
      },
      {
        question: "Are your courses online or in-person?",
        answer: "All IBLI courses are delivered 100% online, allowing you to learn from anywhere in the world at your own pace."
      },
      {
        question: "How long does it take to complete a course?",
        answer: "IBLI courses are fully self-paced. Most courses include 4 to 18 hours of structured learning content, which can be completed within a few days or spread over several weeks depending on your schedule."
      },
      {
        question: "Are your certifications recognized internationally?",
        answer: "IBLI certifications are designed to be internationally accessible and aligned with industry-relevant skills. They support professional development and career growth, but they do not represent formal academic accreditation or guarantee employment outcomes."
      }
    ]
  },
  {
    title: "Enrollment & Access",
    items: [
      {
        question: "Are there any prerequisites for enrollment?",
        answer: "Most IBLI courses are beginner-friendly and do not require prior experience. Some advanced courses may recommend basic knowledge, which will be outlined on the course page."
      },
      {
        question: "How do I enroll in a course?",
        answer: "You can enroll directly through the website by selecting your course and completing the payment process. Access is granted immediately after successful payment."
      },
      {
        question: "Do I get lifetime access to the course?",
        answer: "Yes, once enrolled, you receive lifetime access to the course materials for continuous learning and review."
      }
    ]
  },
  {
    title: "Payments & Refunds",
    items: [
      {
        question: "What payment methods do you accept?",
        answer: "All payments are securely processed through Stripe. We accept major credit and debit cards. Available methods may vary depending on your location."
      },
      {
        question: "Do you offer financial aid or scholarships?",
        answer: "IBLI does not currently offer financial aid or scholarship programs. Courses are priced to remain accessible to a global audience."
      },
      {
        question: "Do you offer installment payment plans?",
        answer: "No, all courses are offered as one-time payments with full access granted after purchase."
      },
      {
        question: "What is your refund policy?",
        answer: "All purchases are final and non-refundable once access to the course has been granted."
      }
    ]
  },
  {
    title: "Certification & Assessment",
    items: [
      {
        question: "How are courses assessed?",
        answer: "Each course includes a final assessment (exam) that evaluates your understanding of the course material."
      },
      {
        question: "What happens if I fail the final exam?",
        answer: "You are allowed up to 3 attempts to pass the final exam. If you do not pass within these attempts, you may need to re-enroll in the course."
      },
      {
        question: "What is the passing score?",
        answer: "A minimum score of 70% is required to successfully pass the final exam and earn your certificate."
      },
      {
        question: "How do I receive my certificate?",
        answer: "Once you successfully pass the final exam, your digital certificate is issued immediately and can be accessed from your account."
      },
      {
        question: "How can employers verify my certificate?",
        answer: "Each certificate includes a unique verification reference. Employers can verify certificates through the Certification Verification section on the IBLI website."
      }
    ]
  },
  {
    title: "Technical Support",
    items: [
      {
        question: "What technical requirements do I need?",
        answer: "You need a stable internet connection and a modern device (desktop, tablet, or smartphone) with an updated web browser."
      },
      {
        question: "What if I experience technical issues?",
        answer: "You can contact our support team via email at admissions@ibliglobal.com. We aim to respond to all inquiries within a reasonable timeframe."
      },
      {
        question: "Can I access course materials offline?",
        answer: "Yes, IBLI allows learners to download course materials for offline access. Please note that assessments, progress tracking, and certificate issuance require an active internet connection."
      }
    ]
  }
];
